<div style="max-height: 92vh;">
    <mat-horizontal-stepper [linear]="isLinear" #stepper>
        <mat-step [stepControl]="firstFormGroup" >
            <form [formGroup]="newPollData">
                <div class="poll-step">
                <ng-template matStepLabel>New Poll</ng-template>
                <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input matInput placeholder="Last name, First name" formControlName="firstCtrl" required formControlName="name">
                </mat-form-field>
                <br>
                <mat-form-field class="example-full-width poll-step">
                    <mat-label>Description</mat-label>
                    <input matInput #message maxlength="256" placeholder="Description" formControlName="description">
                </mat-form-field>
                <br>
                <mat-form-field class="example-full-width poll-step">
                    <mat-label>Message</mat-label>
                    <textarea  
                    matInput 
                    matTextareaAutosize
                    [matAutosizeMinRows]="2"
                    [matAutosizeMaxRows]="4"
                    placeholder="Poll Message Title here ..." 
                    required 
                    formControlName="message"></textarea>
                    <!-- <input matInput #message maxlength="256" placeholder="Message" required formControlName="message"> -->
                </mat-form-field>
                <br>
                <div>
                    <mat-label>Expiry time </mat-label>
                    <ngx-timepicker-field [format]="24" [defaultTime]="'00:00'" [controlOnly]="true" required formControlName="expTime"></ngx-timepicker-field>
                </div>
                <br>
                <mat-form-field appearance="fill">
                    <mat-label>Poll Type</mat-label>
                    <mat-select required formControlName="pollType">
                        <mat-option *ngFor="let item of pollTypes" [value]="item" >
                        {{item | titlecase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <br>
                <mat-slide-toggle [(ngModel)]="allowVote" [ngModelOptions]="{standalone: true}" formControlName="allowVoteChange">
                    Allow Vote Change 
                </mat-slide-toggle>
                <br>
                <br>
                    <mat-slide-toggle [(ngModel)]="adhoc" [ngModelOptions]="{standalone: true}" formControlName="adhoc"> Adhoc </mat-slide-toggle>
                <br>

                <br>
                <mat-slide-toggle [ngModelOptions]="{standalone: true}" formControlName="isLive">
                    Is Live Poll
                </mat-slide-toggle>
                <br>
                
                <br>
                <mat-slide-toggle [(ngModel)]="optIn"  [ngModelOptions]="{standalone: true}" formControlName="optIn">
                    Is opt-in
                </mat-slide-toggle>
                <br>

                <br>
                <mat-slide-toggle  [ngModelOptions]="{standalone: true}" formControlName="close_message">
                    Auto Poll Closing Message.
                </mat-slide-toggle>

                <mat-form-field appearance="fill" *ngIf="!adhoc">
                    <mat-label>Groups</mat-label>
                    <mat-select formControlName="group">
                        <mat-option *ngFor="let item of allGroups" [value]="item" >
                        {{item.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <br>
    
                <mat-form-field *ngIf="adhoc">
                    <mat-label>Members</mat-label>
                    <mat-chip-list #chipListSection>
                        <mat-chip *ngFor="let selectedSection of selectedSections" [selectable]="true"
                            [removable]="true" (removed)="removeSelectedSection(selectedSection)">
                            {{selectedSection?.name}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input placeholder="Select Board Members" #sectionInput [matAutocomplete]="autoSection"
                            [matChipInputFor]="chipListSection">
                    </mat-chip-list>
                    <mat-autocomplete #autoSection="matAutocomplete" (optionSelected)="addSection($event)">
                        <mat-option *ngFor="let section of sections | filter:sectionInput.value"
                            [value]="section">
                            {{section?.name}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <br>
                
                <div> 
                    <button mat-raised-button color="primary" [disabled]="!newPollData.valid" matStepperNext (click)="createNewPoll()">Next</button> 
                </div>
                </div>
            </form>
          
        </mat-step>
        <!-- #docregion label -->
    
        <mat-step [stepControl]="secondFormGroup" label="Options " >
        <!-- #enddocregion label -->
            <div class="poll-step">
                
                <div *ngFor="let data of options let indexOfelement=index;" class="test">
                <div style="float: right; padding-right: 20px; margin-top: 0.1vw;">
                    <mat-icon (click)="handleCancel(indexOfelement)">clear</mat-icon>
                </div>
                <mat-form-field>
                    <mat-label>Option Name</mat-label>
                    <input matInput placeholder="Name"  [(ngModel)] = 'data.Name' required>
                </mat-form-field>
                <br>
                <div *ngIf="selectedPollType != 'ranked-choice'">
                    <mat-form-field>
                        <mat-label>Option Message</mat-label>
                        <input matInput placeholder="Option Message" [(ngModel)] = 'data.Description' required>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Expected Reply</mat-label>
                        <mat-chip-list #chipList >
                            <mat-chip *ngFor="let data1 of data.replayValues let replayValTndex=index;" [selectable]="selectable" [removable]="removable" (removed)="remove(replayValTndex,indexOfelement)">
                            {{data1}}
                            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                            </mat-chip>
                            <input placeholder="Type a value then press enter or comma to add the value.."
                                [matChipInputFor]="chipList"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                [matChipInputAddOnBlur]="addOnBlur"
                                (matChipInputTokenEnd)="add($event, indexOfelement)">
                        </mat-chip-list>
                    </mat-form-field>
                    <br>
                    <mat-form-field appearance="fill" *ngIf="optIn">
                        <mat-label>Group</mat-label>
                        <mat-select [(ngModel)] = 'data.group'>
                          <mat-option *ngFor="let item of allGroups" [value]="item" >
                            {{item.name}}
                          </mat-option>
                        </mat-select>
                    </mat-form-field>
                    </div>
                </div>
                
                <div>
                    <mat-icon (click)="handleAdd()" style="float: right; padding-right: 14vw; margin-top: 0.5vw;">add</mat-icon>
                </div>
                <br>
                <div>
                    <button mat-raised-button color="primary" matStepperPrevious>Back</button> &nbsp;
                    <button mat-raised-button color="primary" *ngIf="selectedPollType == 'quiz'" (click)="handleSavePollOptions()">Next</button>
                    <button mat-raised-button color="primary" (click)="handleSavePollOptions()" *ngIf="selectedPollType != 'quiz'">Save</button>
                </div>
            </div>
        </mat-step>
        
        <mat-step *ngIf="selectedPollType == 'quiz'">
          <ng-template matStepLabel>Done</ng-template>
          <table  style="margin: 10px;" class="table table-striped table-hover" data-row-style="rowStyle">
            <thead>
              <tr>
                <th class="" scope="col">
                  <div  class="actionPadding" title="Name">Name</div>
                </th>
                <th class="" scope="col">
                  <div title="Email">Description</div>
                </th>
                <th class="" scope="col">
                  <div title="Contact">Choose the correct option </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of optionList let indexOfelement=index;">
                
                <td>
                    {{data.name | titlecase}}
                </td>
                <td>
                    {{data.description}}
                </td>
                <td>
                  <mat-radio-button value={{data.id}} (click)="onRadioButtonValueChange(data.id)" [(ngModel)]="correctOptionValue"></mat-radio-button>
                </td>
              
              </tr>
            </tbody>
        </table>
          <div>
            <button mat-raised-button color="primary" matStepperPrevious>Back</button> &nbsp;
            <button mat-raised-button color="primary" (click)="updatePollsWithCorrectOption()">Done</button>
          </div>
        </mat-step>
    </mat-horizontal-stepper>
</div>
